import useUserDetails from '@/hooks/useUserDetails';
import { DhData } from '@/pages/DataHub/DataHub.types';
import { mockDhData } from '@/pages/DataHub/mock/dhData';

import { separator } from './constants';

const useDataHubPreview = (dhData: DhData) => {
  const { isUserPremium, isUserExpired } = useUserDetails();
  const dataToShow = isUserPremium && !isUserExpired ? dhData : mockDhData;

  const groupedData: Record<
    string,
    {
      date: string;
      values: Record<string, { value: string; PeriodAbs: string; FactsheetVersion: string }>;
    }
  > = {};

  dataToShow.forEach(dhDataItem => {
    const transactionTime = dhDataItem.transactionTime;
    const transactionDay = transactionTime.split('T')[0];
    const columnKey = [
      dhDataItem.symbol.TimeRef,
      dhDataItem.symbol.Period,
      dhDataItem.symbol.PeriodType,
      dhDataItem.symbol.Code,
      dhDataItem.metadata.Title
    ].join(separator);

    if (!groupedData[transactionDay]) {
      groupedData[transactionDay] = { date: transactionTime, values: {} };
    }

    groupedData[transactionDay].values[columnKey] = {
      value: dhDataItem.values?.Index ?? dhDataItem.values?.Mid ?? '-',
      PeriodAbs: dhDataItem.values?.PeriodAbs || '-',
      FactsheetVersion: dhDataItem.values?.FactsheetVersion ?? '-'
    };
  });

  const rows = Object.values(groupedData).sort((a, b) => b.date.localeCompare(a.date));

  return { rows };
};

export default useDataHubPreview;
